module.exports = __webpack_public_path__ + "static/media/VaderPay.3902d639.svg";